import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { FaCheckCircle, FaClock, FaExclamationTriangle } from 'react-icons/fa';
import { getSubscriptionCinetPayStatus } from '../services/api';
import { useAuth } from '../context/AuthContext';
import './Checkout.css';

const normalizeStatus = (status) => String(status || 'pending').toLowerCase();

function SubscriptionResult() {
  const [searchParams] = useSearchParams();
  const transaction = searchParams.get('transaction') || '';
  const payment = searchParams.get('payment') || '';
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(payment || 'pending');
  const [subscription, setSubscription] = useState(null);
  const [error, setError] = useState('');
  const { setUser, user } = useAuth();

  useEffect(() => {
    const loadResult = async () => {
      setLoading(true);
      setError('');

      try {
        if (transaction) {
          const response = await getSubscriptionCinetPayStatus(transaction);
          setStatus(response.payment_status || payment || 'pending');
          setSubscription(response.subscription || null);

          if (response.payment_status === 'completed' && response.subscription?.plan_id && user) {
            const updatedUser = { ...user, subscription_plan: response.subscription.plan_id };
            setUser?.(updatedUser);
            localStorage.setItem('userData', JSON.stringify(updatedUser));
          }
        }
      } catch (err) {
        setError(err.message || 'Impossible de verifier le paiement.');
      } finally {
        setLoading(false);
      }
    };

    loadResult();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction, payment]);

  const normalizedStatus = normalizeStatus(status);
  const isSuccess = normalizedStatus === 'success' || normalizedStatus === 'completed';
  const isFailed = normalizedStatus === 'failed';
  const StatusIcon = isSuccess ? FaCheckCircle : isFailed ? FaExclamationTriangle : FaClock;

  if (loading) {
    return (
      <div className="checkout-page">
        <div className="checkout-loading">
          <div className="spinner"></div>
          <p>Vérification du paiement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="checkout-page">
      <section className={`checkout-result-header ${isSuccess ? 'success' : isFailed ? 'failed' : 'pending'}`}>
        <StatusIcon />
        <div>
          <p className="checkout-kicker">Retour CinetPay</p>
          <h1>{isSuccess ? 'Abonnement active' : isFailed ? 'Paiement echoue' : 'Paiement en verification'}</h1>
          <p>
            {isSuccess
              ? `Votre abonnement ${subscription?.plan_name || ''} est maintenant actif.`
              : isFailed
                ? "Le paiement n'a pas été finalisé. Vous pouvez réessayer depuis la page des forfaits."
                : 'La confirmation peut prendre quelques instants. Actualisez cette page si necessaire.'}
          </p>
          {transaction && <code>{transaction}</code>}
        </div>
      </section>

      {error && <div className="error-message checkout-error">{error}</div>}

      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Link to="/dashboard" className="btn-submit" style={{ textDecoration: 'none', display: 'inline-block', padding: '0.85rem 2rem' }}>
          Retour au tableau de bord
        </Link>
      </div>
    </div>
  );
}

export default SubscriptionResult;
